"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAYERS = exports.DISPLAY_FULL_DATE_FORMAT = exports.DISPLAY_DATE_FORMAT = exports.ENTER_KEY = exports.DIRECTION_DOWN = exports.DIRECTION_UP = exports.breakpoints = void 0;
exports.breakpoints = [768, 1024, 1440];
exports.DIRECTION_UP = 'ArrowUp';
exports.DIRECTION_DOWN = 'ArrowDown';
exports.ENTER_KEY = 'Enter';
exports.DISPLAY_DATE_FORMAT = 'd MMM';
exports.DISPLAY_FULL_DATE_FORMAT = 'd MMM yyyy';
exports.LAYERS = {
    farBackground: -20,
    background: -10,
    midground: 0,
    foreground: 10,
    nearForeground: 20,
};
//# sourceMappingURL=react.constants.js.map